// SEO topic hubs (/topics/:slug). A product or article belongs to a topic when one of its tags
// (case-insensitive) is in `tags`, or its title contains one of `titleKeywords`.
// User-facing copy for each topic lives in client/src/locales and server/src/seo/topic-copy.ts.

export interface TopicDefinition {
  slug: string;
  name: string;
  tags: readonly string[];
  titleKeywords: readonly string[];
}

export const TOPICS = [
  {
    slug: "n8n",
    name: "n8n",
    tags: ["n8n", "n8n automation", "workflow"],
    titleKeywords: ["n8n"],
  },
  {
    slug: "ai-agent",
    name: "AI Agent",
    tags: ["ai", "ai agent", "gpt", "llm", "openai", "rag", "prompt engineering", "chatbot"],
    titleKeywords: ["ai agent", "chatbot", "llm", "gpt"],
  },
  {
    slug: "automation",
    name: "Automation",
    tags: ["automation", "workflow automation", "automasi", "otomatisasi", "otomasi", "ai automation"],
    titleKeywords: ["automation", "automasi", "otomatisasi", "otomasi"],
  },
  {
    slug: "saas",
    name: "SaaS",
    tags: ["saas", "build saas cepat dengan ai", "stripe"],
    titleKeywords: ["saas"],
  },
  {
    slug: "vibe-coding",
    name: "Vibe Coding",
    tags: ["vibe coding", "low-code"],
    titleKeywords: ["vibe coding"],
  },
  {
    slug: "hermes",
    name: "Hermes",
    tags: ["hermes", "hermes agent"],
    titleKeywords: ["hermes"],
  },
  {
    slug: "openclaw",
    name: "OpenClaw",
    tags: ["openclaw"],
    titleKeywords: ["openclaw"],
  },
] as const satisfies readonly TopicDefinition[];

export type TopicSlug = (typeof TOPICS)[number]["slug"];

export function findTopic(slug: string): TopicDefinition | undefined {
  return TOPICS.find((topic) => topic.slug === slug);
}

/** A topic page with fewer items than this is served with `noindex` until it has substance. */
export const TOPIC_MIN_INDEXABLE_ITEMS = 3;
